import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.singleContact || initialState;

export const selectSingleContact = createSelector(
  [selectSlice],
  state => state,
);
